import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychooseecommerce() {
  return (
    <section
      className="trusted_ecommerce_web ecommerce_why_choose p-100"
      style={{ background: "#fff" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose Tekrevol For <span>Your Social Media Marketing</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-3 mt-md-0">
            <p>
              TekRevol is the no.1 choice when it comes to custom-tailored
              social media marketing strategies that not only drive user
              engagement but also enhance the brand image. Our data-driven
              research not only guarantees measurable results but also gives
              sustainable growth across different social media platforms.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row className="mt-3 mt-md-5">
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>
                      We Understand Your
                      <br />
                      Industry
                    </h5>
                    <p>
                      With experience across a wide range of industries, we know
                      what works in your market. Our strategies are customized
                      to fit the unique challenges and opportunities in your
                      field.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>
                      A Team of Seasoned
                      <br />
                      Experts
                    </h5>
                    <p>
                      Our team is made up of social media professionals who live
                      and breathe this stuff. From creative content creators to
                      data analysts, we’ve got the right people to make your
                      campaigns shine.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>
                      We Know the
                      <br /> Market
                    </h5>
                    <p>
                      We keep our finger on the pulse of social media trends, so
                      you don’t have to. Our deep understanding of the market
                      helps us craft strategies that hit the mark and keep your
                      brand relevant.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Driven by Data, Inspired by Creativity</h5>
                    <p>
                      Our approach combines the best of both worlds—solid data
                      and creative thinking. We dig into the numbers to inform
                      our strategies and use creativity to make your brand stand
                      out.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">05</div>
                  <div className="ecomm_box_content">
                    <h5>
                      We Work Hand in Hand
                      <br /> with You
                    </h5>
                    <p>
                      We’re not just another social media management service
                      provider; we’re your partner. By working closely with your
                      team, we ensure our campaigns reflect your brand’s voice
                      and align with your goals.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">06</div>
                  <div className="ecomm_box_content">
                    <h5>
                      Custom Solutions for <br /> Your Success
                    </h5>
                    <p>
                      We don’t believe in one-size-fits-all. Every campaign we
                      create is tailored to your specific needs, ensuring it
                      resonates with your audience and delivers real results.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseecommerce;
